export const Configuration = {
  // FRONT_BASEURL: "http://localhost:3000/",
  BACK_BASEURL: process.env.REACT_APP_BACK_BASEURL 
  // || "http://localhost:3001/",
};
export default Configuration;
